(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["art-zen-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('az-review-gallery')) {
    customElements.define('az-review-gallery', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('.azr__track');
        this.cards = [...this.querySelectorAll('.azr__card')];
        this.controls = this.querySelector('.azr__controls');
        this.prev = this.querySelector('.azr__prev');
        this.next = this.querySelector('.azr__next');
        this.counter = this.querySelector('.azr__counter');
        this.prev.addEventListener('click', () => this.move(-1), {signal});
        this.next.addEventListener('click', () => this.move(1), {signal});
        this.track.addEventListener('keydown', e => {
          if (e.target !== this.track) return;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {e.preventDefault();this.move(e.key === 'ArrowLeft' ? -1 : 1);}
        }, {signal});
        this.track.addEventListener('scroll', () => {clearTimeout(this.timer);this.timer=setTimeout(() => this.update(),100);}, {signal,passive:true});
        this.addEventListener('shopify:block:select', e => {
          const card=e.target.closest('.azr__card');if(card)this.track.scrollTo({left:card.offsetLeft-this.cards[0].offsetLeft,behavior:'instant'});
        }, {signal});
        this.observer = new ResizeObserver(() => this.update());this.observer.observe(this.track);this.update();
      }
      update() {
        if (!this.cards.length) {this.controls.hidden=true;return;}
        const step=this.cards.length>1?this.cards[1].offsetLeft-this.cards[0].offsetLeft:this.cards[0].offsetWidth;
        this.index=Math.round(this.track.scrollLeft/step);
        this.controls.hidden=this.track.scrollWidth<=this.track.clientWidth+2;
        this.prev.disabled=this.track.scrollLeft<=2;
        this.next.disabled=this.track.scrollLeft>=this.track.scrollWidth-this.track.clientWidth-2;
        this.counter.textContent=String(this.index+1).padStart(2,'0')+' / '+String(this.cards.length).padStart(2,'0');
      }
      move(direction) {
        const step=this.cards.length>1?this.cards[1].offsetLeft-this.cards[0].offsetLeft:this.track.clientWidth;
        this.track.scrollBy({left:direction*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
      disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();clearTimeout(this.timer);}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["art-zen-text-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('az-text-video')) {
customElements.define('az-text-video', class extends HTMLElement {
connectedCallback() {
const video = this.querySelector('video');
if (!video || !video.autoplay) return;
if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
video.autoplay = false;
video.pause();
video.controls = true;
return;
}
const playback = video.play();
if (playback) playback.catch(() => { if (video.isConnected) video.controls = true; });
}
disconnectedCallback() { this.querySelector('video')?.pause(); }
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["art-zen-universe"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('az-universe')) {
  customElements.define('az-universe', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.observer?.disconnect();
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      const track = this.querySelector('.az-universe__track');
      const prev = this.querySelector('[data-az-prev]');
      const next = this.querySelector('[data-az-next]');
      const controls = this.querySelector('.az-universe__controls');
      const current = this.querySelector('[data-az-current]');
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        controls.hidden = !track.children.length;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
        const card = track.firstElementChild;
        if (card && current) {
          const step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).gap) || 0);
          current.textContent = String(Math.min(track.children.length, Math.max(1, Math.round(track.scrollLeft / step) + 1)));
        }
      };
      const move = direction => {
        const card = track.firstElementChild;
        if (!card) return;
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        track.scrollBy({left: direction * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1), options);
      next.addEventListener('click', () => move(1), options);
      track.addEventListener('scroll', update, options);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.az-universe__card');
        if (card) track.scrollBy({left: card.getBoundingClientRect().left - track.getBoundingClientRect().left - parseFloat(getComputedStyle(track).paddingLeft), behavior:'instant'});
      }, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() { this.abortController?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
function initArtZenArticles(root=document){root.querySelectorAll('[data-az-article]').forEach(article=>{const copy=article.querySelector('[data-az-copy]');const toc=article.querySelector('[data-az-toc]');if(copy&&toc&&!toc.dataset.ready){const headings=copy.querySelectorAll('h2');const list=toc.querySelector('ol');headings.forEach((heading,index)=>{if(!heading.id)heading.id='artzen-section-'+(index+1);const li=document.createElement('li');const a=document.createElement('a');a.href='#'+heading.id;a.textContent=heading.textContent;li.append(a);list.append(li)});toc.hidden=headings.length<3;toc.dataset.ready='true';copy.querySelectorAll('table').forEach(table=>{if(!table.parentElement.classList.contains('az-table-scroll')){const wrapper=document.createElement('div');wrapper.className='az-table-scroll';wrapper.tabIndex=0;table.before(wrapper);wrapper.append(table)}})}const button=article.querySelector('[data-az-share]');if(button&&!button.dataset.ready){button.dataset.ready='true';button.addEventListener('click',async()=>{const url=window.location.origin+window.location.pathname;const status=article.querySelector('.az-share-status');try{if(navigator.share){await navigator.share({title:document.title,url})}else{await navigator.clipboard.writeText(url);status.textContent=button.dataset.success}}catch(error){if(error.name!=='AbortError')status.textContent=button.dataset.error}})}})}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',()=>initArtZenArticles())}else{initArtZenArticles()}
document.addEventListener('shopify:section:load',event=>initArtZenArticles(event.target));

  } catch(e) { console.error(e); }
})();
})();
